import React, { useEffect } from "react";
import { Paper, Box, Typography } from "@material-ui/core";
import { LoginVerifyForm } from "./children/LoginVerifyForm";
import { LoginWrapper } from "./LoginWrapper";
import { IntroText, Loader } from "../../components";
import { GET_PATIENT_BY_PHONE } from "../../queries";
import { useLazyQuery } from "@apollo/react-hooks";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthRedirect, useConsumerAuth } from "../../hooks";

const LoginVerify = () => {
  const { t } = useTranslation();
  const { state = {} } = useLocation();
  const history = useHistory();
  const { getRedirectUrl, removeRedirectUrl } = useAuthRedirect();
  const { updateSession } = useConsumerAuth();

  /**
   * Lookup patient by phone number
   */
  const [getPatientByPhone, { loading, error }] = useLazyQuery(
    GET_PATIENT_BY_PHONE,
    {
      onCompleted: ({ patient = {} }) => {
        if (!patient.status || patient.status !== "success") {
          history.push({ pathname: getRedirectUrl() });

          removeRedirectUrl();
        }
      },
      onError: error => {
        console.log(error);
      }
    }
  );

  /**
   * Check we have phone passed from 2FA
   */
  useEffect(() => {
    if (!state.phone) {
      history.push(`/login`);
    } else {
      getPatientByPhone({
        variables: {
          phone: state.phone
        }
      });
    }
  }, []);

  const onSubmit = ({ dob = "", first_name = "", last_name = "" }) => {
    updateSession({
      dob,
      first_name: first_name.trim(),
      last_name: last_name.trim()
    });

    history.push({
      pathname: getRedirectUrl()
    });

    removeRedirectUrl();
  };

  if (loading) return <Loader />;
  if (error)
    return <Typography color="error">{t("auth.verify.error_api")}</Typography>;

  return (
    <LoginWrapper showLogo={true}>
      <Box mx={2} data-cy="view-auth-verify">
        <Paper>
          <Box p={2} pt={3}>
            <IntroText>{t("auth.verify.intro_text")}</IntroText>
            <LoginVerifyForm onSubmit={onSubmit} />
          </Box>
        </Paper>
      </Box>
    </LoginWrapper>
  );
};

export { LoginVerify };
